import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import {environment} from '../../../environments/environment';
import {AngularFirestore} from '@angular/fire/firestore';
import {SessionService} from '../service/session.service';
import {Router} from '@angular/router';
import {CommonService} from '../service/common.service';
import {MasterService} from '../service/master.service';
import {AlertService} from '../service/alert.service';
import {AppInitService} from '../service/app-init.service';
import {Observable} from 'rxjs';
import {Alert} from '../../shared/interfaces/alert';
import {COLLECTION_NAME} from '../../shared/constants';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {
  @Output() hamburgerClick: EventEmitter<any> = new EventEmitter<any>();
  public opened: boolean;
  color: string;
  title = environment.title;
  title_xs = environment.title_xs;
  ALERT = COLLECTION_NAME.ALERT;
  alertObservable: Observable<Alert[]> = new Observable<Alert[]>();
  constructor(public sessionService: SessionService,
              public commonService: CommonService,
              public masterService: MasterService,
              public alertService: AlertService,
              private appInitService: AppInitService,
              private router: Router) {
    this.color = environment.color;
    this.opened = true;
  }

  /**
   *
   */
  ngOnInit(): void {
    this.appInitService.isInitCompleted$.subscribe((isCompleted: boolean) => {
      console.log('isCompleted', isCompleted);
      if (isCompleted) {
        const farmId = this.commonService.getName(this.masterService.keishaMaster,
          this.sessionService.session.personalSetting?.shozokuKeishaId, 'farmId');
        this.alertObservable = this.alertService.getAlertObservable({farmId, kakuninDate: ''});
      }
    });
  }

  /**
   *
   */
  logout() {

  }

  /**
   * 通常の[routerLink]を使用した遷移では同じ申請種別への遷移時に画面が更新されないため
   * 以下のように一度ダミーURLを経由してから遷移させる
   * https://stackoverflow.com/questions/40983055/how-to-reload-the-current-route-with-the-angular-2-router
   * @param path
   * @param param
   */
  redirectTo(path: string, param = '') {
    console.log(path, param);
    this.router.navigateByUrl('/', {skipLocationChange: true}).then(() => {
      if (param === '') {
        this.router.navigate([path]);
        return;
      }
      this.router.navigate([path, param]);
    });
  }
}
